import { render, staticRenderFns } from "./list-index.vue?vue&type=template&id=49311475&"
import script from "./list-index.vue?vue&type=script&lang=js&"
export * from "./list-index.vue?vue&type=script&lang=js&"
import style0 from "./list-index.vue?vue&type=style&index=0&id=49311475&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports